var map = {
	"./365-fa-logo-extended.svg": 3098,
	"./365-logo-brand.svg": 3099,
	"./365-logo-extended.svg": 3080,
	"./365-logo-premium-gradient.svg": 3100,
	"./365-logo-premium2.svg": 2633,
	"./365-logo-premium3.svg": 2634,
	"./365-logo-sm.svg": 2062,
	"./365-logo.svg": 2024,
	"./CaretRight.svg": 3101,
	"./arrow-right.svg": 494,
	"./autosave.svg": 2063,
	"./calculator-arrow.svg": 1627,
	"./campaign-stars-rating.svg": 1603,
	"./caret-left-circle-outline.svg": 3102,
	"./caret-left-circle.svg": 498,
	"./caret-right-circle-outline.svg": 3103,
	"./caret-right-circle.svg": 499,
	"./caret-right-white.svg": 2635,
	"./caret-right.svg": 547,
	"./carret-down-flashcards.svg": 2636,
	"./carret-down.svg": 2637,
	"./certificate-badge.svg": 2064,
	"./check-campaign-auto.svg": 2025,
	"./check.svg": 3104,
	"./checkout-minus-icon.svg": 2638,
	"./checkout-plus-icon.svg": 2639,
	"./close-icon.svg": 520,
	"./coding-exercise/icon-coding-exercise-ai.svg": 2640,
	"./coding-exercise/icon-coding-exercise-collapse.svg": 2173,
	"./coding-exercise/icon-coding-exercise-scroll.svg": 2641,
	"./coding-exercise/icon-coding-exercise.svg": 2642,
	"./coding-exercise/icon-copy.svg": 3105,
	"./coding-exercise/icon-instructions.svg": 3106,
	"./coding-exercise/icon-openai.svg": 2065,
	"./coding-exercise/icon-solution-code.svg": 3107,
	"./coding-exercise/icon-student.svg": 3108,
	"./companies/campaign-logo-alphabet.svg": 551,
	"./companies/campaign-logo-amazon.svg": 552,
	"./companies/campaign-logo-bank-of-america.svg": 553,
	"./companies/campaign-logo-barclays.svg": 554,
	"./companies/campaign-logo-bnp-paribas.svg": 555,
	"./companies/campaign-logo-coca-cola.svg": 556,
	"./companies/campaign-logo-goldman-sachs.svg": 557,
	"./companies/campaign-logo-hsbc.svg": 530,
	"./companies/campaign-logo-ikea.svg": 558,
	"./companies/campaign-logo-jp-morgan.svg": 559,
	"./companies/campaign-logo-meta.svg": 560,
	"./companies/campaign-logo-morgan-stanley.svg": 561,
	"./companies/campaign-logo-oracle.svg": 562,
	"./companies/campaign-logo-pwc.svg": 563,
	"./companies/campaign-logo-walmart.svg": 564,
	"./companies/icon-amazon-auto.svg": 2643,
	"./companies/icon-apple-auto.svg": 2066,
	"./companies/icon-bank-of-america-auto.svg": 2644,
	"./companies/icon-barclays-auto.svg": 2645,
	"./companies/icon-bnp-auto.svg": 2646,
	"./companies/icon-booking-auto.svg": 2647,
	"./companies/icon-bosch-auto.svg": 2648,
	"./companies/icon-citibank-auto.svg": 2649,
	"./companies/icon-dell-auto.svg": 2650,
	"./companies/icon-deloitte-auto.svg": 2651,
	"./companies/icon-fedex-auto.svg": 2652,
	"./companies/icon-goldman-sachs-auto.svg": 2653,
	"./companies/icon-google-auto.svg": 2067,
	"./companies/icon-hsbc-auto.svg": 2654,
	"./companies/icon-humana-auto.svg": 2655,
	"./companies/icon-ikea-auto.svg": 2656,
	"./companies/icon-j-p-morgan-auto.svg": 2657,
	"./companies/icon-leowe-auto.svg": 2658,
	"./companies/icon-lindt-auto.svg": 2659,
	"./companies/icon-meta-auto.svg": 2068,
	"./companies/icon-microsoft-auto.svg": 2069,
	"./companies/icon-nissan-auto.svg": 2660,
	"./companies/icon-paypal-auto.svg": 2661,
	"./companies/icon-starbucks-auto.svg": 2662,
	"./companies/icon-tesla-auto.svg": 2663,
	"./companies/icon-ups-auto.svg": 2664,
	"./companies/icon-vanguard-auto.svg": 2665,
	"./companies/icon-virgin-media-auto.svg": 2666,
	"./companies/icon-walmart-auto.svg": 2070,
	"./companies/logo-alphabet.svg": 531,
	"./companies/logo-amazon-2.svg": 532,
	"./companies/logo-amazon.svg": 565,
	"./companies/logo-azercell.svg": 566,
	"./companies/logo-bank-of-america.svg": 567,
	"./companies/logo-barclays.svg": 568,
	"./companies/logo-bbc.svg": 569,
	"./companies/logo-bloomberg.svg": 533,
	"./companies/logo-bnp-paribas.svg": 570,
	"./companies/logo-booking.svg": 571,
	"./companies/logo-citibank.svg": 572,
	"./companies/logo-cnbc.svg": 534,
	"./companies/logo-cnbc2.svg": 573,
	"./companies/logo-coca-cola-auto.svg": 535,
	"./companies/logo-coca-cola-white.svg": 1475,
	"./companies/logo-coca-cola.svg": 574,
	"./companies/logo-deloitte.svg": 575,
	"./companies/logo-experian.svg": 576,
	"./companies/logo-facebook.svg": 577,
	"./companies/logo-forbes.svg": 536,
	"./companies/logo-g.svg": 1476,
	"./companies/logo-goldman-sachs-new.svg": 578,
	"./companies/logo-goldman-sachs.svg": 1363,
	"./companies/logo-google-new.svg": 579,
	"./companies/logo-google.svg": 580,
	"./companies/logo-h.svg": 581,
	"./companies/logo-henkel.svg": 582,
	"./companies/logo-hsbc-new.svg": 583,
	"./companies/logo-hsbc.svg": 1364,
	"./companies/logo-ikea-new.svg": 584,
	"./companies/logo-ikea.svg": 1477,
	"./companies/logo-infineon.svg": 585,
	"./companies/logo-instagram-icon.svg": 537,
	"./companies/logo-instagram.svg": 586,
	"./companies/logo-jp-morgan.svg": 587,
	"./companies/logo-jti.svg": 588,
	"./companies/logo-linkedin.svg": 589,
	"./companies/logo-meta-new.svg": 538,
	"./companies/logo-meta.svg": 1365,
	"./companies/logo-morgan-stanley-new.svg": 590,
	"./companies/logo-morgan-stanley.svg": 1366,
	"./companies/logo-netflix.svg": 1367,
	"./companies/logo-oracle.svg": 539,
	"./companies/logo-paypal.svg": 591,
	"./companies/logo-pwc-new.svg": 540,
	"./companies/logo-pwc.svg": 1478,
	"./companies/logo-spotify.svg": 1368,
	"./companies/logo-tesla.svg": 592,
	"./companies/logo-usa-today.svg": 541,
	"./companies/logo-visa.svg": 593,
	"./companies/logo-walmart.svg": 542,
	"./companies/logo-wsj.svg": 543,
	"./companies/logo-youtube.svg": 594,
	"./courses/arrow-right.svg": 1967,
	"./courses/audience-icon.svg": 1878,
	"./courses/certificate-of-achievement.svg": 1968,
	"./courses/check-icon.svg": 1879,
	"./courses/clock-colored.svg": 1395,
	"./courses/clock.svg": 1667,
	"./courses/closed-captions.svg": 1969,
	"./courses/coding-exercises.svg": 1970,
	"./courses/course-exam.svg": 1971,
	"./courses/curriculum-icon.svg": 1880,
	"./courses/downloadable-resources.svg": 1972,
	"./courses/fire.svg": 1973,
	"./courses/future-course-updates.svg": 1974,
	"./courses/hours-of-content.svg": 1975,
	"./courses/icon-book.svg": 1881,
	"./courses/icon-label-bestseller.svg": 1313,
	"./courses/icon-label-free.svg": 1314,
	"./courses/icon-label-new.svg": 1315,
	"./courses/icon-label-popular.svg": 1316,
	"./courses/icon-label-top-rated.svg": 1317,
	"./courses/icon-label-trending.svg": 1318,
	"./courses/icon-lesson-type.svg": 1668,
	"./courses/icon-people.svg": 1882,
	"./courses/icon-star.svg": 1883,
	"./courses/icon-text-lesson-type.svg": 1669,
	"./courses/instructors-icon.svg": 1884,
	"./courses/interactive-exercises-lg.svg": 1885,
	"./courses/interactive-exercises.svg": 1886,
	"./courses/medal-colored.svg": 1976,
	"./courses/medal.svg": 2631,
	"./courses/monitor-colored.svg": 1977,
	"./courses/monitor.svg": 1369,
	"./courses/overview-icon.svg": 1887,
	"./courses/play-circle.svg": 1978,
	"./courses/play.svg": 1979,
	"./courses/practical-tasks-colored.svg": 1980,
	"./courses/practical-tasks.svg": 1981,
	"./courses/projects-icon.svg": 1888,
	"./courses/q-and-a-support.svg": 1982,
	"./courses/replay.svg": 1983,
	"./courses/requirements-icon.svg": 1889,
	"./courses/reviews-icon.svg": 1890,
	"./courses/rocket-icon.svg": 1891,
	"./courses/similar-courses-icon.svg": 1892,
	"./courses/tags-icon.svg": 1893,
	"./courses/topics-icon.svg": 1894,
	"./courses/tracks-icon.svg": 1895,
	"./courses/what-you-learn.svg": 1896,
	"./courses/world-class-instructor.svg": 1984,
	"./curved-arrow.svg": 1639,
	"./ds-cm-lifetime-discount-mobile.svg": 3081,
	"./ds-cm-lifetime-discount.svg": 3082,
	"./ds-cm-lifetime-plan-mobile.svg": 3083,
	"./ds-cm-lifetime-plan.svg": 3084,
	"./ds-fw2024-free.svg": 2071,
	"./editor-js/ejs-edit.svg": 1670,
	"./editor-js/ejs-hover-icon-delete.svg": 3109,
	"./editor-js/ejs-hover-icon-move-down.svg": 3110,
	"./editor-js/ejs-hover-icon-move-up.svg": 3111,
	"./editor-js/ejs-icon-code.svg": 1985,
	"./editor-js/ejs-icon-delete.svg": 1986,
	"./editor-js/ejs-icon-equation.svg": 1987,
	"./editor-js/ejs-icon-highlight.svg": 1988,
	"./editor-js/ejs-icon-info.svg": 1989,
	"./editor-js/ejs-icon-move-down.svg": 1990,
	"./editor-js/ejs-icon-move-up.svg": 1991,
	"./editor-js/ejs-icon-spoiler.svg": 1992,
	"./editor-js/ejs-icon-text.svg": 1993,
	"./editor-js/ejs-icon-warning.svg": 1994,
	"./editor-js/link-template/article-background.svg": 3112,
	"./editor-js/link-template/bookmark-background.svg": 3113,
	"./editor-js/link-template/other-background.svg": 3114,
	"./editor-js/link-template/video-background.svg": 3115,
	"./editor-js/link-template/website-background.svg": 3116,
	"./editor-resize-handle.svg": 3117,
	"./editor/bold.svg": 3118,
	"./editor/emoji.svg": 3119,
	"./editor/image.svg": 3120,
	"./editor/italic.svg": 3121,
	"./editor/language-arrow-editor-rotate.svg": 3122,
	"./editor/language-arrow-editor.svg": 3123,
	"./editor/link.svg": 3124,
	"./editor/underline.svg": 3125,
	"./equation/icon-equation-accent-1.svg": 2174,
	"./equation/icon-equation-accent-10.svg": 2175,
	"./equation/icon-equation-accent-11.svg": 2176,
	"./equation/icon-equation-accent-12.svg": 2177,
	"./equation/icon-equation-accent-13.svg": 2178,
	"./equation/icon-equation-accent-14.svg": 2179,
	"./equation/icon-equation-accent-15.svg": 2180,
	"./equation/icon-equation-accent-16.svg": 2181,
	"./equation/icon-equation-accent-17.svg": 2182,
	"./equation/icon-equation-accent-18.svg": 2183,
	"./equation/icon-equation-accent-19.svg": 2184,
	"./equation/icon-equation-accent-2.svg": 2185,
	"./equation/icon-equation-accent-20.svg": 2186,
	"./equation/icon-equation-accent-21.svg": 2187,
	"./equation/icon-equation-accent-22.svg": 2188,
	"./equation/icon-equation-accent-3.svg": 2189,
	"./equation/icon-equation-accent-4.svg": 2190,
	"./equation/icon-equation-accent-5.svg": 2191,
	"./equation/icon-equation-accent-6.svg": 2192,
	"./equation/icon-equation-accent-7.svg": 2193,
	"./equation/icon-equation-accent-8.svg": 2194,
	"./equation/icon-equation-accent-9.svg": 2195,
	"./equation/icon-equation-accent.svg": 2196,
	"./equation/icon-equation-bracket-1.svg": 2197,
	"./equation/icon-equation-bracket-10.svg": 2198,
	"./equation/icon-equation-bracket-11.svg": 2199,
	"./equation/icon-equation-bracket-12.svg": 2200,
	"./equation/icon-equation-bracket-13.svg": 2201,
	"./equation/icon-equation-bracket-14.svg": 2202,
	"./equation/icon-equation-bracket-15.svg": 2203,
	"./equation/icon-equation-bracket-16.svg": 2204,
	"./equation/icon-equation-bracket-17.svg": 2205,
	"./equation/icon-equation-bracket-18.svg": 2206,
	"./equation/icon-equation-bracket-19.svg": 2207,
	"./equation/icon-equation-bracket-2.svg": 2208,
	"./equation/icon-equation-bracket-20.svg": 2209,
	"./equation/icon-equation-bracket-21.svg": 2210,
	"./equation/icon-equation-bracket-22.svg": 2211,
	"./equation/icon-equation-bracket-23.svg": 2212,
	"./equation/icon-equation-bracket-24.svg": 2213,
	"./equation/icon-equation-bracket-25.svg": 2214,
	"./equation/icon-equation-bracket-26.svg": 2215,
	"./equation/icon-equation-bracket-27.svg": 2216,
	"./equation/icon-equation-bracket-28.svg": 2217,
	"./equation/icon-equation-bracket-29.svg": 2218,
	"./equation/icon-equation-bracket-3.svg": 2219,
	"./equation/icon-equation-bracket-30.svg": 2220,
	"./equation/icon-equation-bracket-31.svg": 2221,
	"./equation/icon-equation-bracket-32.svg": 2222,
	"./equation/icon-equation-bracket-33.svg": 2223,
	"./equation/icon-equation-bracket-34.svg": 2224,
	"./equation/icon-equation-bracket-35.svg": 2225,
	"./equation/icon-equation-bracket-36.svg": 2226,
	"./equation/icon-equation-bracket-37.svg": 2227,
	"./equation/icon-equation-bracket-4.svg": 2228,
	"./equation/icon-equation-bracket-5.svg": 2229,
	"./equation/icon-equation-bracket-6.svg": 2230,
	"./equation/icon-equation-bracket-7.svg": 2231,
	"./equation/icon-equation-bracket-8.svg": 2232,
	"./equation/icon-equation-bracket-9.svg": 2233,
	"./equation/icon-equation-bracket.svg": 2234,
	"./equation/icon-equation-caps-lock-2.svg": 2235,
	"./equation/icon-equation-caps-lock.svg": 2236,
	"./equation/icon-equation-fraction-1.svg": 2237,
	"./equation/icon-equation-fraction-2.svg": 2238,
	"./equation/icon-equation-fraction-3.svg": 2239,
	"./equation/icon-equation-fraction-4.svg": 2240,
	"./equation/icon-equation-fraction-5.svg": 2241,
	"./equation/icon-equation-fraction-6.svg": 2242,
	"./equation/icon-equation-fraction-7.svg": 2243,
	"./equation/icon-equation-fraction-8.svg": 2244,
	"./equation/icon-equation-fraction.svg": 2245,
	"./equation/icon-equation-function-1.svg": 2246,
	"./equation/icon-equation-function-10.svg": 2247,
	"./equation/icon-equation-function-11.svg": 2248,
	"./equation/icon-equation-function-12.svg": 2249,
	"./equation/icon-equation-function-13.svg": 2250,
	"./equation/icon-equation-function-14.svg": 2251,
	"./equation/icon-equation-function-15.svg": 2252,
	"./equation/icon-equation-function-16.svg": 2253,
	"./equation/icon-equation-function-2.svg": 2254,
	"./equation/icon-equation-function-3.svg": 2255,
	"./equation/icon-equation-function-4.svg": 2256,
	"./equation/icon-equation-function-5.svg": 2257,
	"./equation/icon-equation-function-6.svg": 2258,
	"./equation/icon-equation-function-7.svg": 2259,
	"./equation/icon-equation-function-8.svg": 2260,
	"./equation/icon-equation-function-9.svg": 2261,
	"./equation/icon-equation-function.svg": 2262,
	"./equation/icon-equation-integral-1.svg": 2263,
	"./equation/icon-equation-integral-10.svg": 2264,
	"./equation/icon-equation-integral-11.svg": 2265,
	"./equation/icon-equation-integral-12.svg": 2266,
	"./equation/icon-equation-integral-13.svg": 2267,
	"./equation/icon-equation-integral-14.svg": 2268,
	"./equation/icon-equation-integral-15.svg": 2269,
	"./equation/icon-equation-integral-16.svg": 2270,
	"./equation/icon-equation-integral-17.svg": 2271,
	"./equation/icon-equation-integral-2.svg": 2272,
	"./equation/icon-equation-integral-3.svg": 2273,
	"./equation/icon-equation-integral-4.svg": 2274,
	"./equation/icon-equation-integral-5.svg": 2275,
	"./equation/icon-equation-integral-6.svg": 2276,
	"./equation/icon-equation-integral-7.svg": 2277,
	"./equation/icon-equation-integral-8.svg": 2278,
	"./equation/icon-equation-integral-9.svg": 2279,
	"./equation/icon-equation-integral.svg": 2280,
	"./equation/icon-equation-large-operator-1.svg": 2281,
	"./equation/icon-equation-large-operator-2.svg": 2282,
	"./equation/icon-equation-large-operator-3.svg": 2283,
	"./equation/icon-equation-large-operator-4.svg": 2284,
	"./equation/icon-equation-large-operator-5.svg": 2285,
	"./equation/icon-equation-large-operator-6.svg": 2286,
	"./equation/icon-equation-large-operator.svg": 2287,
	"./equation/icon-equation-limit-1.svg": 2288,
	"./equation/icon-equation-limit-2.svg": 2289,
	"./equation/icon-equation-limit-3.svg": 2290,
	"./equation/icon-equation-limit-4.svg": 2291,
	"./equation/icon-equation-limit-5.svg": 2292,
	"./equation/icon-equation-limit-6.svg": 2293,
	"./equation/icon-equation-limit-7.svg": 2294,
	"./equation/icon-equation-limit.svg": 2295,
	"./equation/icon-equation-matrix-1.svg": 2296,
	"./equation/icon-equation-matrix-2.svg": 2297,
	"./equation/icon-equation-matrix-3.svg": 2298,
	"./equation/icon-equation-matrix-4.svg": 2299,
	"./equation/icon-equation-matrix-5.svg": 2300,
	"./equation/icon-equation-matrix-6.svg": 2301,
	"./equation/icon-equation-matrix.svg": 2302,
	"./equation/icon-equation-numbers.svg": 2303,
	"./equation/icon-equation-operator-1.svg": 2304,
	"./equation/icon-equation-operator-10.svg": 2305,
	"./equation/icon-equation-operator-11.svg": 2306,
	"./equation/icon-equation-operator-12.svg": 2307,
	"./equation/icon-equation-operator-13.svg": 2308,
	"./equation/icon-equation-operator-14.svg": 2309,
	"./equation/icon-equation-operator-15.svg": 2310,
	"./equation/icon-equation-operator-16.svg": 2311,
	"./equation/icon-equation-operator-17.svg": 2312,
	"./equation/icon-equation-operator-18.svg": 2313,
	"./equation/icon-equation-operator-19.svg": 2314,
	"./equation/icon-equation-operator-2.svg": 2315,
	"./equation/icon-equation-operator-3.svg": 2316,
	"./equation/icon-equation-operator-4.svg": 2317,
	"./equation/icon-equation-operator-5.svg": 2318,
	"./equation/icon-equation-operator-6.svg": 2319,
	"./equation/icon-equation-operator-7.svg": 2320,
	"./equation/icon-equation-operator-8.svg": 2321,
	"./equation/icon-equation-operator-9.svg": 2322,
	"./equation/icon-equation-operator.svg": 2323,
	"./equation/icon-equation-radical-1.svg": 2324,
	"./equation/icon-equation-radical-2.svg": 2325,
	"./equation/icon-equation-radical.svg": 2326,
	"./equation/icon-equation-script-1.svg": 2327,
	"./equation/icon-equation-script-2.svg": 2328,
	"./equation/icon-equation-script-3.svg": 2329,
	"./equation/icon-equation-script-4.svg": 2330,
	"./equation/icon-equation-script.svg": 2331,
	"./equation/icon-equation-symbol-1.svg": 2332,
	"./equation/icon-equation-symbol-10.svg": 2333,
	"./equation/icon-equation-symbol-100.svg": 2334,
	"./equation/icon-equation-symbol-101.svg": 2335,
	"./equation/icon-equation-symbol-102.svg": 2336,
	"./equation/icon-equation-symbol-103.svg": 2337,
	"./equation/icon-equation-symbol-104.svg": 2338,
	"./equation/icon-equation-symbol-105.svg": 2339,
	"./equation/icon-equation-symbol-106.svg": 2340,
	"./equation/icon-equation-symbol-107.svg": 2341,
	"./equation/icon-equation-symbol-108.svg": 2342,
	"./equation/icon-equation-symbol-109.svg": 2343,
	"./equation/icon-equation-symbol-11.svg": 2344,
	"./equation/icon-equation-symbol-110.svg": 2345,
	"./equation/icon-equation-symbol-111.svg": 2346,
	"./equation/icon-equation-symbol-112.svg": 2347,
	"./equation/icon-equation-symbol-113.svg": 2348,
	"./equation/icon-equation-symbol-114.svg": 2349,
	"./equation/icon-equation-symbol-115.svg": 2350,
	"./equation/icon-equation-symbol-116.svg": 2351,
	"./equation/icon-equation-symbol-117.svg": 2352,
	"./equation/icon-equation-symbol-118.svg": 2353,
	"./equation/icon-equation-symbol-119.svg": 2354,
	"./equation/icon-equation-symbol-12.svg": 2355,
	"./equation/icon-equation-symbol-120.svg": 2356,
	"./equation/icon-equation-symbol-121.svg": 2357,
	"./equation/icon-equation-symbol-122.svg": 2358,
	"./equation/icon-equation-symbol-123.svg": 2359,
	"./equation/icon-equation-symbol-124.svg": 2360,
	"./equation/icon-equation-symbol-125.svg": 2361,
	"./equation/icon-equation-symbol-126.svg": 2362,
	"./equation/icon-equation-symbol-127.svg": 2363,
	"./equation/icon-equation-symbol-128.svg": 2364,
	"./equation/icon-equation-symbol-129.svg": 2365,
	"./equation/icon-equation-symbol-13.svg": 2366,
	"./equation/icon-equation-symbol-130.svg": 2367,
	"./equation/icon-equation-symbol-131.svg": 2368,
	"./equation/icon-equation-symbol-132.svg": 2369,
	"./equation/icon-equation-symbol-133.svg": 2370,
	"./equation/icon-equation-symbol-134.svg": 2371,
	"./equation/icon-equation-symbol-135.svg": 2372,
	"./equation/icon-equation-symbol-136.svg": 2373,
	"./equation/icon-equation-symbol-137.svg": 2374,
	"./equation/icon-equation-symbol-138.svg": 2375,
	"./equation/icon-equation-symbol-139.svg": 2376,
	"./equation/icon-equation-symbol-14.svg": 2377,
	"./equation/icon-equation-symbol-140.svg": 2378,
	"./equation/icon-equation-symbol-141.svg": 2379,
	"./equation/icon-equation-symbol-142.svg": 2380,
	"./equation/icon-equation-symbol-143.svg": 2381,
	"./equation/icon-equation-symbol-144.svg": 2382,
	"./equation/icon-equation-symbol-145.svg": 2383,
	"./equation/icon-equation-symbol-146.svg": 2384,
	"./equation/icon-equation-symbol-147.svg": 2385,
	"./equation/icon-equation-symbol-148.svg": 2386,
	"./equation/icon-equation-symbol-149.svg": 2387,
	"./equation/icon-equation-symbol-15.svg": 2388,
	"./equation/icon-equation-symbol-150.svg": 2389,
	"./equation/icon-equation-symbol-151.svg": 2390,
	"./equation/icon-equation-symbol-152.svg": 2391,
	"./equation/icon-equation-symbol-153.svg": 2392,
	"./equation/icon-equation-symbol-154.svg": 2393,
	"./equation/icon-equation-symbol-155.svg": 2394,
	"./equation/icon-equation-symbol-156.svg": 2395,
	"./equation/icon-equation-symbol-157.svg": 2396,
	"./equation/icon-equation-symbol-158.svg": 2397,
	"./equation/icon-equation-symbol-159.svg": 2398,
	"./equation/icon-equation-symbol-16.svg": 2399,
	"./equation/icon-equation-symbol-160.svg": 2400,
	"./equation/icon-equation-symbol-161.svg": 2401,
	"./equation/icon-equation-symbol-162.svg": 2402,
	"./equation/icon-equation-symbol-163.svg": 2403,
	"./equation/icon-equation-symbol-164.svg": 2404,
	"./equation/icon-equation-symbol-165.svg": 2405,
	"./equation/icon-equation-symbol-166.svg": 2406,
	"./equation/icon-equation-symbol-167.svg": 2407,
	"./equation/icon-equation-symbol-168.svg": 2408,
	"./equation/icon-equation-symbol-169.svg": 2409,
	"./equation/icon-equation-symbol-17.svg": 2410,
	"./equation/icon-equation-symbol-170.svg": 2411,
	"./equation/icon-equation-symbol-171.svg": 2412,
	"./equation/icon-equation-symbol-172.svg": 2413,
	"./equation/icon-equation-symbol-173.svg": 2414,
	"./equation/icon-equation-symbol-174.svg": 2415,
	"./equation/icon-equation-symbol-175.svg": 2416,
	"./equation/icon-equation-symbol-176.svg": 2417,
	"./equation/icon-equation-symbol-177.svg": 2418,
	"./equation/icon-equation-symbol-178.svg": 2419,
	"./equation/icon-equation-symbol-179.svg": 2420,
	"./equation/icon-equation-symbol-18.svg": 2421,
	"./equation/icon-equation-symbol-180.svg": 2422,
	"./equation/icon-equation-symbol-181.svg": 2423,
	"./equation/icon-equation-symbol-182.svg": 2424,
	"./equation/icon-equation-symbol-183.svg": 2425,
	"./equation/icon-equation-symbol-184.svg": 2426,
	"./equation/icon-equation-symbol-185.svg": 2427,
	"./equation/icon-equation-symbol-186.svg": 2428,
	"./equation/icon-equation-symbol-187.svg": 2429,
	"./equation/icon-equation-symbol-188.svg": 2430,
	"./equation/icon-equation-symbol-189.svg": 2431,
	"./equation/icon-equation-symbol-19.svg": 2432,
	"./equation/icon-equation-symbol-190.svg": 2433,
	"./equation/icon-equation-symbol-191.svg": 2434,
	"./equation/icon-equation-symbol-192.svg": 2435,
	"./equation/icon-equation-symbol-193.svg": 2436,
	"./equation/icon-equation-symbol-194.svg": 2437,
	"./equation/icon-equation-symbol-195.svg": 2438,
	"./equation/icon-equation-symbol-196.svg": 2439,
	"./equation/icon-equation-symbol-197.svg": 2440,
	"./equation/icon-equation-symbol-198.svg": 2441,
	"./equation/icon-equation-symbol-199.svg": 2442,
	"./equation/icon-equation-symbol-2.svg": 2443,
	"./equation/icon-equation-symbol-20.svg": 2444,
	"./equation/icon-equation-symbol-200.svg": 2445,
	"./equation/icon-equation-symbol-201.svg": 2446,
	"./equation/icon-equation-symbol-202.svg": 2447,
	"./equation/icon-equation-symbol-203.svg": 2448,
	"./equation/icon-equation-symbol-204.svg": 2449,
	"./equation/icon-equation-symbol-205.svg": 2450,
	"./equation/icon-equation-symbol-206.svg": 2451,
	"./equation/icon-equation-symbol-207.svg": 2452,
	"./equation/icon-equation-symbol-208.svg": 2453,
	"./equation/icon-equation-symbol-209.svg": 2454,
	"./equation/icon-equation-symbol-21.svg": 2455,
	"./equation/icon-equation-symbol-210.svg": 2456,
	"./equation/icon-equation-symbol-211.svg": 2457,
	"./equation/icon-equation-symbol-212.svg": 2458,
	"./equation/icon-equation-symbol-213.svg": 2459,
	"./equation/icon-equation-symbol-214.svg": 2460,
	"./equation/icon-equation-symbol-215.svg": 2461,
	"./equation/icon-equation-symbol-216.svg": 2462,
	"./equation/icon-equation-symbol-217.svg": 2463,
	"./equation/icon-equation-symbol-218.svg": 2464,
	"./equation/icon-equation-symbol-219.svg": 2465,
	"./equation/icon-equation-symbol-22.svg": 2466,
	"./equation/icon-equation-symbol-220.svg": 2467,
	"./equation/icon-equation-symbol-221.svg": 2468,
	"./equation/icon-equation-symbol-222.svg": 2469,
	"./equation/icon-equation-symbol-223.svg": 2470,
	"./equation/icon-equation-symbol-224.svg": 2471,
	"./equation/icon-equation-symbol-225.svg": 2472,
	"./equation/icon-equation-symbol-226.svg": 2473,
	"./equation/icon-equation-symbol-227.svg": 2474,
	"./equation/icon-equation-symbol-228.svg": 2475,
	"./equation/icon-equation-symbol-229.svg": 2476,
	"./equation/icon-equation-symbol-23.svg": 2477,
	"./equation/icon-equation-symbol-230.svg": 2478,
	"./equation/icon-equation-symbol-231.svg": 2479,
	"./equation/icon-equation-symbol-232.svg": 2480,
	"./equation/icon-equation-symbol-233.svg": 2481,
	"./equation/icon-equation-symbol-234.svg": 2482,
	"./equation/icon-equation-symbol-235.svg": 2483,
	"./equation/icon-equation-symbol-236.svg": 2484,
	"./equation/icon-equation-symbol-237.svg": 2485,
	"./equation/icon-equation-symbol-238.svg": 2486,
	"./equation/icon-equation-symbol-239.svg": 2487,
	"./equation/icon-equation-symbol-24.svg": 2488,
	"./equation/icon-equation-symbol-240.svg": 2489,
	"./equation/icon-equation-symbol-241.svg": 2490,
	"./equation/icon-equation-symbol-242.svg": 2491,
	"./equation/icon-equation-symbol-243.svg": 2492,
	"./equation/icon-equation-symbol-244.svg": 2493,
	"./equation/icon-equation-symbol-245.svg": 2494,
	"./equation/icon-equation-symbol-246.svg": 2495,
	"./equation/icon-equation-symbol-247.svg": 2496,
	"./equation/icon-equation-symbol-248.svg": 2497,
	"./equation/icon-equation-symbol-249.svg": 2498,
	"./equation/icon-equation-symbol-25.svg": 2499,
	"./equation/icon-equation-symbol-250.svg": 2500,
	"./equation/icon-equation-symbol-251.svg": 2501,
	"./equation/icon-equation-symbol-252.svg": 2502,
	"./equation/icon-equation-symbol-253.svg": 2503,
	"./equation/icon-equation-symbol-254.svg": 2504,
	"./equation/icon-equation-symbol-255.svg": 2505,
	"./equation/icon-equation-symbol-256.svg": 2506,
	"./equation/icon-equation-symbol-257.svg": 2507,
	"./equation/icon-equation-symbol-258.svg": 2508,
	"./equation/icon-equation-symbol-259.svg": 2509,
	"./equation/icon-equation-symbol-26.svg": 2510,
	"./equation/icon-equation-symbol-260.svg": 2511,
	"./equation/icon-equation-symbol-261.svg": 2512,
	"./equation/icon-equation-symbol-262.svg": 2513,
	"./equation/icon-equation-symbol-263.svg": 2514,
	"./equation/icon-equation-symbol-264.svg": 2515,
	"./equation/icon-equation-symbol-265.svg": 2516,
	"./equation/icon-equation-symbol-266.svg": 2517,
	"./equation/icon-equation-symbol-267.svg": 2518,
	"./equation/icon-equation-symbol-268.svg": 2519,
	"./equation/icon-equation-symbol-269.svg": 2520,
	"./equation/icon-equation-symbol-27.svg": 2521,
	"./equation/icon-equation-symbol-270.svg": 2522,
	"./equation/icon-equation-symbol-271.svg": 2523,
	"./equation/icon-equation-symbol-272.svg": 2524,
	"./equation/icon-equation-symbol-273.svg": 2525,
	"./equation/icon-equation-symbol-274.svg": 2526,
	"./equation/icon-equation-symbol-275.svg": 2527,
	"./equation/icon-equation-symbol-276.svg": 2528,
	"./equation/icon-equation-symbol-28.svg": 2529,
	"./equation/icon-equation-symbol-29.svg": 2530,
	"./equation/icon-equation-symbol-3.svg": 2531,
	"./equation/icon-equation-symbol-30.svg": 2532,
	"./equation/icon-equation-symbol-31.svg": 2533,
	"./equation/icon-equation-symbol-32.svg": 2534,
	"./equation/icon-equation-symbol-33.svg": 2535,
	"./equation/icon-equation-symbol-34.svg": 2536,
	"./equation/icon-equation-symbol-35.svg": 2537,
	"./equation/icon-equation-symbol-36.svg": 2538,
	"./equation/icon-equation-symbol-37.svg": 2539,
	"./equation/icon-equation-symbol-38.svg": 2540,
	"./equation/icon-equation-symbol-39.svg": 2541,
	"./equation/icon-equation-symbol-4.svg": 2542,
	"./equation/icon-equation-symbol-40.svg": 2543,
	"./equation/icon-equation-symbol-41.svg": 2544,
	"./equation/icon-equation-symbol-42.svg": 2545,
	"./equation/icon-equation-symbol-43.svg": 2546,
	"./equation/icon-equation-symbol-44.svg": 2547,
	"./equation/icon-equation-symbol-45.svg": 2548,
	"./equation/icon-equation-symbol-46.svg": 2549,
	"./equation/icon-equation-symbol-47.svg": 2550,
	"./equation/icon-equation-symbol-48.svg": 2551,
	"./equation/icon-equation-symbol-49.svg": 2552,
	"./equation/icon-equation-symbol-5.svg": 2553,
	"./equation/icon-equation-symbol-50.svg": 2554,
	"./equation/icon-equation-symbol-51.svg": 2555,
	"./equation/icon-equation-symbol-52.svg": 2556,
	"./equation/icon-equation-symbol-53.svg": 2557,
	"./equation/icon-equation-symbol-54.svg": 2558,
	"./equation/icon-equation-symbol-55.svg": 2559,
	"./equation/icon-equation-symbol-56.svg": 2560,
	"./equation/icon-equation-symbol-57.svg": 2561,
	"./equation/icon-equation-symbol-58.svg": 2562,
	"./equation/icon-equation-symbol-59.svg": 2563,
	"./equation/icon-equation-symbol-6.svg": 2564,
	"./equation/icon-equation-symbol-60.svg": 2565,
	"./equation/icon-equation-symbol-61.svg": 2566,
	"./equation/icon-equation-symbol-62.svg": 2567,
	"./equation/icon-equation-symbol-63.svg": 2568,
	"./equation/icon-equation-symbol-64.svg": 2569,
	"./equation/icon-equation-symbol-65.svg": 2570,
	"./equation/icon-equation-symbol-66.svg": 2571,
	"./equation/icon-equation-symbol-67.svg": 2572,
	"./equation/icon-equation-symbol-68.svg": 2573,
	"./equation/icon-equation-symbol-69.svg": 2574,
	"./equation/icon-equation-symbol-7.svg": 2575,
	"./equation/icon-equation-symbol-70.svg": 2576,
	"./equation/icon-equation-symbol-71.svg": 2577,
	"./equation/icon-equation-symbol-72.svg": 2578,
	"./equation/icon-equation-symbol-73.svg": 2579,
	"./equation/icon-equation-symbol-74.svg": 2580,
	"./equation/icon-equation-symbol-75.svg": 2581,
	"./equation/icon-equation-symbol-76.svg": 2582,
	"./equation/icon-equation-symbol-77.svg": 2583,
	"./equation/icon-equation-symbol-78.svg": 2584,
	"./equation/icon-equation-symbol-79.svg": 2585,
	"./equation/icon-equation-symbol-8.svg": 2586,
	"./equation/icon-equation-symbol-80.svg": 2587,
	"./equation/icon-equation-symbol-81.svg": 2588,
	"./equation/icon-equation-symbol-82.svg": 2589,
	"./equation/icon-equation-symbol-83.svg": 2590,
	"./equation/icon-equation-symbol-84.svg": 2591,
	"./equation/icon-equation-symbol-85.svg": 2592,
	"./equation/icon-equation-symbol-86.svg": 2593,
	"./equation/icon-equation-symbol-87.svg": 2594,
	"./equation/icon-equation-symbol-88.svg": 2595,
	"./equation/icon-equation-symbol-89.svg": 2596,
	"./equation/icon-equation-symbol-9.svg": 2597,
	"./equation/icon-equation-symbol-90.svg": 2598,
	"./equation/icon-equation-symbol-91.svg": 2599,
	"./equation/icon-equation-symbol-92.svg": 2600,
	"./equation/icon-equation-symbol-93.svg": 2601,
	"./equation/icon-equation-symbol-94.svg": 2602,
	"./equation/icon-equation-symbol-95.svg": 2603,
	"./equation/icon-equation-symbol-96.svg": 2604,
	"./equation/icon-equation-symbol-97.svg": 2605,
	"./equation/icon-equation-symbol-98.svg": 2606,
	"./equation/icon-equation-symbol-99.svg": 2607,
	"./equation/icon-equation-symbol.svg": 2608,
	"./equation/icon-menu-accent.svg": 2667,
	"./equation/icon-menu-arrows.svg": 2668,
	"./equation/icon-menu-basic-math.svg": 2669,
	"./equation/icon-menu-bracket.svg": 2670,
	"./equation/icon-menu-fraction.svg": 2671,
	"./equation/icon-menu-function.svg": 2672,
	"./equation/icon-menu-geometry.svg": 2673,
	"./equation/icon-menu-greek.svg": 2674,
	"./equation/icon-menu-integral.svg": 2675,
	"./equation/icon-menu-large-operator.svg": 2676,
	"./equation/icon-menu-letter-like.svg": 2677,
	"./equation/icon-menu-letters.svg": 2678,
	"./equation/icon-menu-limit.svg": 2679,
	"./equation/icon-menu-matrix.svg": 2680,
	"./equation/icon-menu-operator.svg": 2681,
	"./equation/icon-menu-operators.svg": 2682,
	"./equation/icon-menu-radical.svg": 2683,
	"./equation/icon-menu-script.svg": 2684,
	"./equation/icon-menu-text.svg": 2685,
	"./exams/arrow.svg": 1671,
	"./exams/correct-answer.svg": 2686,
	"./exams/excel.svg": 3126,
	"./exams/icon-star.svg": 3127,
	"./exams/incorrect-answer.svg": 2687,
	"./exams/pdf.svg": 3128,
	"./exams/python.svg": 3129,
	"./exams/unknown.svg": 1640,
	"./exercise/blank-typing.svg": 1995,
	"./exercise/blank.svg": 1996,
	"./exercise/category.svg": 1997,
	"./exercise/matrix.svg": 1998,
	"./exercise/multiple-choice.svg": 1999,
	"./exercise/order.svg": 2000,
	"./exercise/single-choice.svg": 2001,
	"./exercise/true-false.svg": 2002,
	"./eye-closed-lash.svg": 3085,
	"./eye-closed.svg": 3130,
	"./eye-opened.svg": 3131,
	"./eye.svg": 2688,
	"./fa-cm-lifetime-discount-mobile.svg": 3086,
	"./fa-cm-lifetime-discount.svg": 3087,
	"./fa-cm-lifetime-plan-mobile.svg": 3088,
	"./fa-cm-lifetime-plan.svg": 3089,
	"./fa-fw2024-free.svg": 2072,
	"./fa/fa-icon-checked-blue.svg": 3132,
	"./flashcards/browse-deck.svg": 2073,
	"./flashcards/click-hand.svg": 2689,
	"./flashcards/load-arrow.svg": 2074,
	"./flashcards/reload-deck.svg": 2075,
	"./flashcards/restart-review.svg": 3133,
	"./flashcards/review-small-eye.svg": 2690,
	"./flashcards/send-result.svg": 2691,
	"./flashcards/take-test.svg": 2076,
	"./flashcards/white-left-arrow.svg": 2692,
	"./gfx-certificate-circle.svg": 3134,
	"./gfx-certificate-excel.svg": 3135,
	"./gfx-certificate-git.svg": 3136,
	"./gfx-certificate-powerbi.svg": 3137,
	"./gfx-certificate-python.svg": 3138,
	"./gfx-certificate-r.svg": 3139,
	"./gfx-certificate-tableau.svg": 3140,
	"./gfx-certificate-theory.svg": 3141,
	"./gfx-hats-left.svg": 3142,
	"./gfx-hats-right.svg": 3143,
	"./icon-404-lms-courses.svg": 2693,
	"./icon-404-lms-practice.svg": 2694,
	"./icon-404-lms-qa.svg": 2695,
	"./icon-admin-difficulty-0.svg": 1356,
	"./icon-admin-difficulty-1.svg": 1357,
	"./icon-admin-difficulty-2.svg": 1358,
	"./icon-admin-info.svg": 1359,
	"./icon-alert.svg": 2696,
	"./icon-arrow-back.svg": 528,
	"./icon-arrow-blue.svg": 2697,
	"./icon-arrow-down-resizable.svg": 1672,
	"./icon-arrow-down.svg": 1673,
	"./icon-arrow-dropdown-down.svg": 2609,
	"./icon-arrow-dropdown.svg": 2077,
	"./icon-arrow-expand.svg": 1628,
	"./icon-arrow-gray.svg": 1604,
	"./icon-arrow-left.svg": 1325,
	"./icon-arrow-next-new.svg": 2078,
	"./icon-arrow-prev-new.svg": 2079,
	"./icon-arrow-right.svg": 1641,
	"./icon-arrow-up.svg": 2026,
	"./icon-arrow.svg": 1674,
	"./icon-assignment.svg": 2698,
	"./icon-audience-1.svg": 2080,
	"./icon-audience-2.svg": 2081,
	"./icon-audience-3.svg": 2082,
	"./icon-back.svg": 2027,
	"./icon-backspace.svg": 2610,
	"./icon-basket.svg": 2083,
	"./icon-berkeley-uni.svg": 2084,
	"./icon-bin.svg": 2085,
	"./icon-black-filled-arrow.svg": 2699,
	"./icon-bug.svg": 2611,
	"./icon-bulb.svg": 2700,
	"./icon-career-track.svg": 2086,
	"./icon-certificate.svg": 2087,
	"./icon-certificates.svg": 2701,
	"./icon-check-blue-bold.svg": 2702,
	"./icon-check-circle.svg": 1642,
	"./icon-check-extreme-fucsia.svg": 2703,
	"./icon-check-list.svg": 2704,
	"./icon-check-projects.svg": 1643,
	"./icon-check.svg": 2088,
	"./icon-checkbox.svg": 2705,
	"./icon-checked-accent-light-3.svg": 2706,
	"./icon-checked-bf.svg": 2707,
	"./icon-checked-blue.svg": 2708,
	"./icon-checked-cm.svg": 2709,
	"./icon-checked-ds-accent.svg": 2710,
	"./icon-checked-extreme-blue-2.svg": 2711,
	"./icon-checked-extreme-magenta.svg": 2712,
	"./icon-checked-extreme-orange.svg": 2713,
	"./icon-checked-extreme-red.svg": 2714,
	"./icon-checked-mw.svg": 2715,
	"./icon-checked-purple.svg": 2716,
	"./icon-checked-tyf.svg": 2717,
	"./icon-checked-yellow-bold.svg": 2718,
	"./icon-checked-yellow.svg": 2719,
	"./icon-checked.svg": 2720,
	"./icon-checkmark.svg": 2721,
	"./icon-chicago-uni.svg": 2089,
	"./icon-circle-check.svg": 2722,
	"./icon-clear-filters.svg": 2723,
	"./icon-clock-colored.svg": 2724,
	"./icon-clock.svg": 2090,
	"./icon-close.svg": 489,
	"./icon-closemark.svg": 2725,
	"./icon-clp-trash.svg": 638,
	"./icon-code.svg": 2726,
	"./icon-coding-exercise-type.svg": 2727,
	"./icon-colored-google.svg": 2728,
	"./icon-colored-linkedin-fill.svg": 2729,
	"./icon-columbia-uni.svg": 2091,
	"./icon-comment.svg": 1675,
	"./icon-complete-program.svg": 2730,
	"./icon-completed.svg": 2731,
	"./icon-copy-text.svg": 2732,
	"./icon-copy.svg": 2003,
	"./icon-course-banner.svg": 2733,
	"./icon-course-content.svg": 1676,
	"./icon-course-exam-type.svg": 2734,
	"./icon-courses.svg": 2735,
	"./icon-curriculum-review-comment-resolved.svg": 2736,
	"./icon-curriculum-review-comment.svg": 2737,
	"./icon-curriculum-validation-error.svg": 2738,
	"./icon-description-type.svg": 2739,
	"./icon-difficulty-advanced-2.svg": 2028,
	"./icon-difficulty-advanced.svg": 2092,
	"./icon-difficulty-beginner-2.svg": 2029,
	"./icon-difficulty-beginner.svg": 2093,
	"./icon-difficulty-intermediate-2.svg": 2030,
	"./icon-difficulty-intermediate.svg": 2094,
	"./icon-down-arrow.svg": 2095,
	"./icon-download-arrow.svg": 2740,
	"./icon-download-sm.svg": 2741,
	"./icon-download.svg": 2742,
	"./icon-download2.svg": 2612,
	"./icon-drag-dots.svg": 2743,
	"./icon-editor-bold.svg": 2744,
	"./icon-editor-code.svg": 2745,
	"./icon-editor-codeblock.svg": 2746,
	"./icon-editor-emoji.svg": 2747,
	"./icon-editor-image.svg": 2748,
	"./icon-editor-italic.svg": 2749,
	"./icon-editor-link.svg": 2750,
	"./icon-editor-strike.svg": 2751,
	"./icon-empty-folder.svg": 2752,
	"./icon-enter.svg": 2613,
	"./icon-exam-clock.svg": 1629,
	"./icon-exam-download.svg": 2753,
	"./icon-exam-flag.svg": 1598,
	"./icon-exam-question-type.svg": 2754,
	"./icon-exam-question.svg": 1677,
	"./icon-exam-share-result.svg": 2755,
	"./icon-exam-summary-type.svg": 2756,
	"./icon-exam-warning.svg": 1322,
	"./icon-exams-subtract.svg": 2614,
	"./icon-exclamation-red.svg": 1678,
	"./icon-exclamation.svg": 2031,
	"./icon-exercise-type.svg": 2757,
	"./icon-exit.svg": 2758,
	"./icon-eye.svg": 2615,
	"./icon-facebook-white.svg": 2759,
	"./icon-facebook.svg": 2760,
	"./icon-faq-expand.svg": 714,
	"./icon-fb.svg": 2004,
	"./icon-film.svg": 2005,
	"./icon-filter-sort.svg": 1897,
	"./icon-filter.svg": 1898,
	"./icon-flashcards-arrow.svg": 2096,
	"./icon-header-back-arrow.svg": 2006,
	"./icon-help.svg": 2761,
	"./icon-home.svg": 2762,
	"./icon-info.svg": 519,
	"./icon-inlinecode.svg": 2763,
	"./icon-iphone.svg": 2007,
	"./icon-language.svg": 2097,
	"./icon-laptop.svg": 2008,
	"./icon-latex.svg": 2616,
	"./icon-learn.svg": 2098,
	"./icon-lesson-locked.svg": 2764,
	"./icon-lesson-text-type.svg": 2009,
	"./icon-lesson-type.svg": 2765,
	"./icon-library-badge-advanced.svg": 1679,
	"./icon-library-badge-beginner.svg": 1680,
	"./icon-library-badge-intermediate.svg": 1681,
	"./icon-lightbulb.svg": 1644,
	"./icon-link.svg": 2766,
	"./icon-linkedin-white.svg": 2767,
	"./icon-linkedin.svg": 2010,
	"./icon-locked.svg": 1966,
	"./icon-mail.svg": 513,
	"./icon-mathview.svg": 2617,
	"./icon-menu-arrow.svg": 2768,
	"./icon-menu-collapse.svg": 2618,
	"./icon-mobile-filter.svg": 2769,
	"./icon-monitor.svg": 2011,
	"./icon-newsfeed-comment.svg": 2770,
	"./icon-newsfeed-edit.svg": 2771,
	"./icon-newsfeed-learners.svg": 2772,
	"./icon-newsfeed-like.svg": 2773,
	"./icon-newsfeed-remove.svg": 2774,
	"./icon-newsfeed-report.svg": 2775,
	"./icon-newsfeed-snooze.svg": 2776,
	"./icon-newsfeed-trophy.svg": 2777,
	"./icon-notifications-bell.svg": 2778,
	"./icon-pencil-nofill.svg": 2779,
	"./icon-pencil-small-edit.svg": 2780,
	"./icon-pencil.svg": 2099,
	"./icon-penn-uni.svg": 2100,
	"./icon-people.svg": 1682,
	"./icon-photo.svg": 2781,
	"./icon-pin.svg": 1370,
	"./icon-play-accent.svg": 2101,
	"./icon-play-active.svg": 2782,
	"./icon-play-circle.svg": 1683,
	"./icon-play.svg": 2783,
	"./icon-plus-gray-fill.svg": 1326,
	"./icon-plus-in-square.svg": 1684,
	"./icon-plus.svg": 1685,
	"./icon-practice-exam-type.svg": 2784,
	"./icon-practice.svg": 2785,
	"./icon-price.svg": 2102,
	"./icon-pricing-arrow-down.svg": 2103,
	"./icon-pricing-badge.svg": 2104,
	"./icon-pricing-check.svg": 2105,
	"./icon-princeton-uni.svg": 2106,
	"./icon-project-content.svg": 2107,
	"./icon-project-featured.svg": 2108,
	"./icon-project-files.svg": 2032,
	"./icon-project-related-courses.svg": 2109,
	"./icon-project-solution-files.svg": 2110,
	"./icon-project-topics.svg": 2111,
	"./icon-project-type.svg": 2786,
	"./icon-project.svg": 2787,
	"./icon-qa-ask.svg": 2788,
	"./icon-qa-delete-answer.svg": 2789,
	"./icon-qa-diamond.svg": 2790,
	"./icon-qa-edit-answer.svg": 2791,
	"./icon-qa-ellipsis-v.svg": 2112,
	"./icon-qa-follow.svg": 2113,
	"./icon-qa-followed.svg": 2792,
	"./icon-qa-glasses.svg": 2793,
	"./icon-qa-magnifier.svg": 2794,
	"./icon-qa-mark.svg": 2114,
	"./icon-qa-report.svg": 2795,
	"./icon-qa-resolve.svg": 2115,
	"./icon-qa-unassign.svg": 2116,
	"./icon-qa.svg": 2796,
	"./icon-question-mark.svg": 1605,
	"./icon-question.svg": 637,
	"./icon-quiz.svg": 2797,
	"./icon-quote-testimonials.svg": 550,
	"./icon-quote.svg": 2117,
	"./icon-rating-star.svg": 2798,
	"./icon-refresh.svg": 2118,
	"./icon-remaining-time.svg": 2799,
	"./icon-replay-accent.svg": 2119,
	"./icon-replay.svg": 2800,
	"./icon-reset-2.svg": 2120,
	"./icon-reset.svg": 2801,
	"./icon-resources.svg": 2802,
	"./icon-review-comments.svg": 2803,
	"./icon-review-indicator.svg": 1606,
	"./icon-review-star.svg": 2121,
	"./icon-reviewed-comments.svg": 2804,
	"./icon-scroll-top.svg": 2805,
	"./icon-search-assignment.svg": 2806,
	"./icon-search-certificate.svg": 2807,
	"./icon-search-code.svg": 2808,
	"./icon-search-course-notes.svg": 2809,
	"./icon-search-course.svg": 2810,
	"./icon-search-dataset.svg": 2811,
	"./icon-search-lesson.svg": 2812,
	"./icon-search-progress-0.svg": 2813,
	"./icon-search-progress-1.svg": 2814,
	"./icon-search-progress-2.svg": 2815,
	"./icon-search-project.svg": 2816,
	"./icon-search-questions.svg": 2817,
	"./icon-search-quiz.svg": 2818,
	"./icon-search-resource.svg": 2819,
	"./icon-search-time.svg": 2820,
	"./icon-search.svg": 1327,
	"./icon-section-locked.svg": 2821,
	"./icon-send.svg": 2822,
	"./icon-share-score.svg": 2823,
	"./icon-share.svg": 2122,
	"./icon-share2.svg": 2824,
	"./icon-shield.svg": 2825,
	"./icon-shuffle.svg": 2123,
	"./icon-site-linkedin.svg": 1686,
	"./icon-site-search.svg": 2826,
	"./icon-site-twitter.svg": 2827,
	"./icon-snooze.svg": 2828,
	"./icon-sort.svg": 1899,
	"./icon-star.svg": 2829,
	"./icon-stock-down.svg": 2830,
	"./icon-stock-up.svg": 2831,
	"./icon-subtract-unlocked.svg": 2832,
	"./icon-subtract.svg": 2833,
	"./icon-sync.svg": 2033,
	"./icon-text-based-exclamation.svg": 1607,
	"./icon-text-based-play.svg": 1481,
	"./icon-text-based-question.svg": 2834,
	"./icon-text-lesson-type.svg": 2835,
	"./icon-tinymce-bold.svg": 2836,
	"./icon-tinymce-code.svg": 2837,
	"./icon-tinymce-codeblock.svg": 2838,
	"./icon-tinymce-emoji.svg": 2839,
	"./icon-tinymce-italic.svg": 2840,
	"./icon-tinymce-link.svg": 2841,
	"./icon-tinymce-strike.svg": 2842,
	"./icon-tinymce-submit.svg": 2843,
	"./icon-trash.svg": 1900,
	"./icon-trustpilot.svg": 1645,
	"./icon-twitter.svg": 2012,
	"./icon-up-arrow.svg": 1646,
	"./icon-vertical-dots.svg": 2844,
	"./icon-video-cc.svg": 2845,
	"./icon-video-full-screen.svg": 2846,
	"./icon-video-mute.svg": 2847,
	"./icon-video-pause.svg": 2848,
	"./icon-video-play.svg": 2849,
	"./icon-video-rewind.svg": 2850,
	"./icon-video-settings.svg": 2851,
	"./icon-video-transcript.svg": 2852,
	"./icon-video-volume.svg": 2853,
	"./icon-warning-gray.svg": 1687,
	"./icon-warning.svg": 1647,
	"./icon-x.svg": 2854,
	"./icon-youtube.svg": 2855,
	"./linkedin-logo.svg": 3144,
	"./loading-spinner.svg": 2013,
	"./medal.svg": 1688,
	"./minus-icon.svg": 2856,
	"./money-back-guarantee.svg": 2014,
	"./offline.svg": 2124,
	"./player/cc.svg": 3145,
	"./player/fullscreen.svg": 3146,
	"./player/mute.svg": 3147,
	"./player/pause.svg": 3148,
	"./player/play-v2-sm.svg": 3149,
	"./player/play-v2.svg": 3150,
	"./player/play.svg": 3151,
	"./player/polygon.svg": 3152,
	"./player/rewind.svg": 3153,
	"./player/settings.svg": 3154,
	"./player/volume.svg": 3155,
	"./plus-icon.svg": 2857,
	"./projects-guided-unguided.svg": 3156,
	"./projects-instruction.svg": 3157,
	"./projects-quiz.svg": 3158,
	"./rounded-quotes-big.svg": 2858,
	"./rounded-quotes.svg": 3159,
	"./saved.svg": 2125,
	"./select-arrow.svg": 3160,
	"./select-dropdown-arrow.svg": 3161,
	"./signatures/company-linkedin.svg": 3162,
	"./signatures/company-youtube.svg": 3163,
	"./small-icon-download.svg": 2126,
	"./sql.svg": 3164,
	"./stars.svg": 2859,
	"./tech-apache-airflow.svg": 2127,
	"./tech-excel.svg": 2128,
	"./tech-git.svg": 2129,
	"./tech-google-sheets.svg": 2130,
	"./tech-gray-chatgpt.svg": 1337,
	"./tech-gray-excel.svg": 1338,
	"./tech-gray-git.svg": 1339,
	"./tech-gray-google-sheets.svg": 1340,
	"./tech-gray-jupyter.svg": 1341,
	"./tech-gray-multiple.svg": 1342,
	"./tech-gray-other.svg": 1343,
	"./tech-gray-powerbi.svg": 1344,
	"./tech-gray-python.svg": 1345,
	"./tech-gray-r.svg": 1346,
	"./tech-gray-sql.svg": 1347,
	"./tech-gray-tableau.svg": 1348,
	"./tech-gray-theory.svg": 1349,
	"./tech-powerbi.svg": 2131,
	"./tech-python (2).svg": 2132,
	"./tech-python.svg": 2133,
	"./tech-r.svg": 2134,
	"./tech-responsive-apache-airflow.svg": 615,
	"./tech-responsive-artificial-intelligence.svg": 548,
	"./tech-responsive-azure.svg": 616,
	"./tech-responsive-chatgpt.svg": 617,
	"./tech-responsive-copilot.svg": 618,
	"./tech-responsive-data.svg": 619,
	"./tech-responsive-excel.svg": 620,
	"./tech-responsive-git.svg": 621,
	"./tech-responsive-google-cloud.svg": 622,
	"./tech-responsive-google-sheets.svg": 623,
	"./tech-responsive-hugging-face.svg": 624,
	"./tech-responsive-jupyter.svg": 625,
	"./tech-responsive-langchain.svg": 626,
	"./tech-responsive-llama.svg": 627,
	"./tech-responsive-multiple.svg": 628,
	"./tech-responsive-powerbi.svg": 629,
	"./tech-responsive-powerpoint.svg": 630,
	"./tech-responsive-python.svg": 631,
	"./tech-responsive-r.svg": 632,
	"./tech-responsive-shell.svg": 633,
	"./tech-responsive-sql.svg": 634,
	"./tech-responsive-tableau.svg": 635,
	"./tech-responsive-theory.svg": 636,
	"./tech-sql.svg": 2135,
	"./tech-tableau.svg": 2136,
	"./tech-theory.svg": 2137,
	"./tightly-arrow.svg": 3165,
	"./topic-responsive-business analytics.svg": 3166,
	"./topic-responsive-business-analytics.svg": 3167,
	"./topic-responsive-career-development.svg": 3168,
	"./topic-responsive-data-analysis.svg": 3169,
	"./topic-responsive-data-processing.svg": 3170,
	"./topic-responsive-data-science.svg": 3171,
	"./topic-responsive-data-visualization.svg": 3172,
	"./topic-responsive-deep-learning.svg": 3173,
	"./topic-responsive-financial-analysis.svg": 3174,
	"./topic-responsive-machine-learning.svg": 3175,
	"./topic-responsive-mathematics.svg": 3176,
	"./topic-responsive-programming.svg": 3177,
	"./vector.svg": 3178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3097;